import { render, staticRenderFns } from "./user-withdrawal-order.vue?vue&type=template&id=5c1296e2&scoped=true&"
import script from "./user-withdrawal-order.vue?vue&type=script&lang=js&"
export * from "./user-withdrawal-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1296e2",
  null
  
)

export default component.exports